/**
 * Partner order enums and shared order-related constants.
 */

export enum EPartnerOrderPaymentMethod {
  COD = "COD",
  CARD = "CARD",
  UPI = "UPI",
  NET_BANKING = "NET_BANKING",
}

export enum EPartnerOrderItemType {
  KIT = "KIT",
}

export enum EPartnerOrderStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  PAID = "PAID",
  FAILED = "FAILED",
  SHIPPED = "SHIPPED",
  DELIVERED = "DELIVERED",
  CANCELLED = "CANCELLED",
}

export enum EPartnerOrderSource {
  ONBOARDING = "ONBOARDING",
  MANUAL = "MANUAL",
  API = "API",
}

export interface IPartnerOrderDeliveryAddressDo {
  area: string;
  city: string;
  state?: string;
  pincode?: string;
  houseNumber: string;
  floor?: string;
  society?: string;
  landmark?: string;
}

export const ORDER_SOURCE = {
  APP: "APP",
  WEB: "WEB",
  DASHBOARD: "DASHBOARD",
  WALKER_APP: "WALKER_APP",
  GROOMER_APP: "GROOMER_APP",
  SYSTEM: "SYSTEM",
} as const;

export type EOrderSource = keyof typeof ORDER_SOURCE;
export const EOrderSource = ORDER_SOURCE;

export const FILTER_ALL_VALUE = "all" as const;

export const COIN_LIMITS = {
  MAX_DEBIT_PERCENTAGE_PER_ORDER: 10,
  MAX_CREDIT_PERCENTAGE_PER_ORDER: 5,
} as const;
